import styled from 'styled-components'
import { useTranslation } from 'react-i18next'
import { Modal } from '../../../../components/modals/Modal'
import { OnClickButton } from '../../../../components/buttons/onclick/OnClickButton'
import { theme } from '../../../../theme/theme'

interface HealthCallTimeslotExpiredModalProps {
  isOpen: boolean
  onClose: () => void
}

export const HealthCallTimeslotExpiredModal = ({ isOpen, onClose }: HealthCallTimeslotExpiredModalProps) => {
  const { t } = useTranslation()

  if (!isOpen) return null

  return (
    <Modal onClose={onClose} maxWidth="480px" backgroundColor={theme.color.beigeLight}>
      <ModalContent>
        <Title>{t('employee.healthCall.timeslotExpired')}</Title>
        <InfoCard>
          <Message>{t('employee.healthCall.timeslotExpiredMessage')}</Message>
        </InfoCard>
        <OnClickButton text={t('employee.healthCall.timeslotExpiredButton')} onClick={onClose} />
      </ModalContent>
    </Modal>
  )
}

const ModalContent = styled.div`
  padding: ${theme.spacing.xlarge}px;
  display: flex;
  flex-direction: column;
  gap: ${theme.spacing.large}px;
  @media screen and (max-width: ${theme.breakpoint.medium}px) {
    padding: 0;
  }
`

const Title = styled.h2`
  margin: 0;
  font-size: ${theme.fontSize.large}px;
  color: ${theme.color.black};
  text-align: center;
  font-weight: 400;
`

const InfoCard = styled.div`
  background-color: ${theme.color.white};
  border-radius: ${theme.spacing.small}px;
  padding: ${theme.spacing.medium}px;
`

const Message = styled.p`
  font-size: ${theme.fontSize.small}px;
  color: ${theme.color.black};
  margin: 0;
  line-height: 1.5;
`
